export enum RiskRegisterControlLinkType {
    RiskAssessment = 0,
    RiskTreatment = 1
}